import { ADD_STREAM_MESSAGE, addMessage, addTextLastMessage, clearStreamMessages, hideWait, showWait, updateNextChunkIndex } from "../actions";

export const streamMessageMiddleware = store => next => action => {
  if (action.type === ADD_STREAM_MESSAGE) {
    const { streamMessages, nextChunkIndex, ignoreMessagesBeforeSequenceId } = store.getState().chatBody

    if (ignoreMessagesBeforeSequenceId && action.message.input_sequence_id <= ignoreMessagesBeforeSequenceId) {
      return
    }

    store.dispatch(showWait())

    if (!streamMessages.length) {
      const text = action.message.chunk_order === 0 ? action.message.text : ''
      store.dispatch(addMessage({ ...action.message, text }))

      // If the first message is also the last message
      if (action.message.is_the_last_chunk) {
        store.dispatch(hideWait())
        return;
      } else if (action.message.chunk_order === 0) {
        store.dispatch(updateNextChunkIndex(action.message.chunk_order + 1))
      }
    } else if (nextChunkIndex === action.message.chunk_order) {
      const { text, nextChunkIndex: index } = getMessageTilEnd(nextChunkIndex, [...streamMessages, action.message])

      store.dispatch(addTextLastMessage(text))
      store.dispatch(updateNextChunkIndex(index))

      // Index = 0 mean Last chunk
      if (index === 0) {
        store.dispatch(hideWait())
        store.dispatch(clearStreamMessages())
        return;
      }
    }
  }

  return next(action);
};

function getMessageTilEnd(chunkIndex, messages) {
  const sortedMessages = [...messages]
    .filter(message => message.chunk_order >= chunkIndex)
    .sort((a, b) => b.chunk_order - a.chunk_order);

  let nextChunkIndex = chunkIndex
  let text = ''

  while (sortedMessages.length) {
    const message = sortedMessages.pop()

    if (message.chunk_order === nextChunkIndex) {
      text += message.text

      if (message.is_the_last_chunk) {
        nextChunkIndex = 0
        break
      }

      nextChunkIndex += 1
    } else {
      break
    }
  }

  return { text, nextChunkIndex }
}
